import { createMiddleware } from "@tanstack/react-start";

/**
 * Webbläsarversion av requireSupabaseAuth.
 *
 * Den riktiga kontrollen körs bara på servern (.server()), men eftersom
 * serverfunktionerna listar mellanlagret i sin deklaration följde hela
 * databasbiblioteket (~200 kB) med in i startpaketet. I klientbygget byts
 * modulen därför ut mot den här tomma varianten – samma form, ingen kod.
 */
export const requireSupabaseAuth = createMiddleware({ type: "function" }).server(
  async ({ next }) => next(),
);
